/** @jsx jsx */
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import { SafePureComponent } from '../../../../utils/SafePureComponent';

import * as styles from './index.styles';

class FormHolder extends SafePureComponent {
  safeRender() {
    const { children } = this.props;

    return (
      <div css={styles.formfield}>
        <div className="h2result">{children}</div>
      </div>
    );
  }
}

FormHolder.displayName = 'BookVisit/FormHolder';

export default compose(withNamespaces())(FormHolder);
